import React, { Suspense } from "react";
import { connect } from "react-redux";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import "./i18n";
import AuthRoute from "./routers/AuthRoute";
import PrivateRoute from "./routers/PrivateRoute";
import AuthVerify from "./AuthVerify";
import AuthForm from "./views/Auth/AuthForm";
import Dashboard from "./views/users/Dashboard";
import Report from "./views/Report";
import Tools from "./views/Tools";
import users from "./views/users";
import Settings from "./views/Settings";
import GlobalLoader from "./components/common/GlobalLoader";
import CommonBootstrapModal from "./components/common/CommonBootstrapModal";

const ViewUser = React.lazy(() =>
  import(/* webpackChunkName: "views-admin" */ "./views/users")
);

const CardInvoice = React.lazy(() =>
  import(/* webpackChunkName: "views-admin" */ "./views/voucher")
);

const SimInvoice = React.lazy(() =>
  import(/* webpackChunkName: "views-admin" */ "./views/Sim")
);

const App = () => {
  return (
    <Suspense fallback={<div className="loading" />}>
      <GlobalLoader />
      <CommonBootstrapModal />
      <Router>
        <div>
          {/* Language Switcher */}

          <Switch>
            <AuthRoute path="/" exact component={() => <AuthForm />} />
            <PrivateRoute path="/users" component={users} />
            <PrivateRoute path="/voucher" component={CardInvoice} />
            <PrivateRoute path="/sim" component={SimInvoice} />
            <PrivateRoute path="/report" component={Report} />
            <PrivateRoute path="/tools" component={Tools} />
            <PrivateRoute path="/settings" component={Settings} />
            <PrivateRoute path="/" component={() => <ViewUser />} />
          </Switch>
          <AuthVerify />
        </div>
      </Router>
    </Suspense>
  );
};

export default App;
